// Notification settings (A7U4), owned by hand: which notifications reach the person on which channel.
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '../../components/ui/page-header'
import { NotificationPreferences } from '../../features/notifications/NotificationPreferences'
import { notificationPreferencesQuery } from '../../features/notifications/queries'
import '../../features/notifications/strings'
import { Part } from '../../shared/shell/StatePart'

export const Route = createFileRoute('/account/notifications')({
  staticData: { screenId: 'NotificationPreferencesScreen', access: 'signed in' },
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(notificationPreferencesQuery()),
  component: NotificationPreferencesScreen,
})

function NotificationPreferencesScreen() {
  const { t } = useTranslation()
  return (
    // The header stands outside the Part, so the page is named while the matrix loads (E22U6).
    <main data-testid={ids.notificationPreferences.root} className="flex flex-col gap-(--stack-lg)">
      <PageHeader title={t('notifications.preferences.title')}>
        <p className="text-fg-muted">{t('notifications.preferences.lede')}</p>
      </PageHeader>
      <Part testId={ids.notificationPreferences.skeleton}>
        <NotificationPreferences />
      </Part>
    </main>
  )
}
